"use client"

import styles from "../../index.module.scss"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function RichText(props: AdComponentTypes) {
  const { AdList, style } = props
  return (
    <div className={`${prefixCls} ${styles.richtext}`}>
      <div
        className={styles.artLabelImg}
        style={{
          width: AdList.len,
          height: AdList.width,
          overflow: "hidden",
          ...style,
        }}
      >
        <ul className={styles.list}>
          {AdList.adverts?.map((item) => (
            <li className={styles.smallAdv} key={item.id}>
              <a href={item.link_url} target="_blank" rel="noreferrer">
                <p>{item.context}</p>
              </a>
            </li>
          ))}
        </ul>

        {AdList.adverts?.map((item, index) => {
          if (index === 0 && item.is_inner == 0) {
            return (
              <div key={item.id} className={styles.isAdOrSmm}>
                AD
              </div>
            )
          }
        })}
      </div>
    </div>
  )
}
